// src/store/rootReducer.js

import homeReducer               from './reducers/homeReducer'
import authReducer               from './reducers/authReducer'
import cardReducer               from './reducers/cardReducer'
import orderReducer              from './reducers/orderReducer'
import dashboardReducer          from './reducers/dashboardReducer'
import chatReducer               from './reducers/chatReducer'
import customerShippingReducer   from './reducers/customerShippingReducer'
import blogClientReducer         from './reducers/blogClientReducer'
import customerActivityReducer   from './reducers/customerActivitySlice'
import vtoReducer                from './reducers/vtoReducer'
import profileReducer            from './reducers/profileSlice'
import forWomenCategoriesReducer from './reducers/forwomenCategoriesReducer'
import hyperDeliveryListReducer  from './reducers/HyperDeliveryReducer'
import shiprocketReducer   from './reducers/shiprocketReducer'// ← new
import virtualSwapReducer        from './reducers/virtualSwapReducer'   
import creditsReducer    from './reducers/creditsSlice'
const rootReducers = {
  home:               homeReducer,
  auth:               authReducer,
  card:               cardReducer,
  order:              orderReducer,
  dashboard:          dashboardReducer,
  chat:               chatReducer,
  blogs:              blogClientReducer,
  customer:           customerShippingReducer,
  customerActivity:   customerActivityReducer,
  vto:                vtoReducer,
  profile:            profileReducer,
  forWomenCategories: forWomenCategoriesReducer,
  hyperDeliveryList:  hyperDeliveryListReducer,
  shiprocket: shiprocketReducer,// ← new
  virtualSwap:        virtualSwapReducer,
  credits:            creditsReducer
}

export default rootReducers
